import { BaseHeaderLayout } from '@components';
import styled from 'styled-components';

export const BaseHeaderLayoutWrapper = styled(BaseHeaderLayout)`
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;
    padding: 40px 16px;
    display: flex;
    align-items: center;
    height: 80px;

    .ant-btn-icon {
        margin-top: 4px;
    }
`;

export const LogoWrapper = styled.div`
    max-width: 280px;
    min-width: 155px;
    height: inherit;
    display: flex;
    padding: 8px 0 8px 14px;
    cursor: pointer;

    img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }

    svg {
        width: 100%;
        height: auto;
    }
`;

export const LeftSection = styled.div`
    display: flex;
    align-items: center;
    height: 80px;
`;
